import React from 'react';
import { PlayButton as RobloxPlayButton } from 'Roblox';
import metadataConstants from '../constants/metadataConstants';
import eventStreamConstants from '../../common/constants/eventStreamConstants';
import usePageReferralTracker from '../../common/hooks/usePageReferralTracker';

const { usePlayabilityStatus, DefaultPlayButton } = RobloxPlayButton;

export default function PlayButton(): JSX.Element {
  const { universeId = '', rootPlaceId = '' } = metadataConstants.metadataData() || {};
  const [playabilityStatus, refetchPlayabilityStatus] = usePlayabilityStatus(universeId);

  const referralParams = usePageReferralTracker(
    eventStreamConstants.gameDetailReferral,
    [
      'isAd',
      'page',
      'placeId',
      'universeId',
      'sortPos',
      'position',
      'gameSetTypeId',
      'gameSetTargetId',
      'homePageSessionInfo',
      'gameSearchSessionInfo',
      'numberOfLoadedTiles'
    ],
    ['privateServerLinkCode']
  );

  return (
    <DefaultPlayButton
      placeId={rootPlaceId}
      universeId={universeId}
      refetchPlayabilityStatus={refetchPlayabilityStatus}
      playabilityStatus={playabilityStatus}
      eventProperties={{
        gameSearchSessionInfo: referralParams.gameSearchSessionInfo,
        homePageSessionInfo: referralParams.homePageSessionInfo,
        page: referralParams.page,
        sortPos: referralParams.sortPos,
        gameSetTypeId: referralParams.gameSetTypeId
      }}
    />
  );
}
